
/**
 * Animation helper that can execute multiple animations in a row
 *
 * @param {HTMLElement} el
 * @param {Array} animations
 */
export function executeAnimationSequence(el, animations = []) {
    const animationToHandle      = animations.shift();
    const animationClass         = animationToHandle.classToAdd;
    const animationDelay         = animationToHandle.relativeDelay ? animationToHandle.relativeDelay : 0;
    const animationDuration      = animationToHandle.duration ? animationToHandle.duration : null;
    const onStartCallback        = animationToHandle.onStart ? animationToHandle.onStart : () => {};
    const onFinishCallback       = animationToHandle.onFinish ? animationToHandle.onFinish : () => {};
    const onHalfwayPointCallback = animationToHandle.onHalfwayPoint ? animationToHandle.onHalfwayPoint : () => {};

    setTimeout(() => {
        onStartCallback();

        if (! el) {
            return;
        }
        el.classList.add(animationClass);

        // If we know the animation duration, we can provide the halfway point callback
        if (animationDuration) {
            setTimeout(() => onHalfwayPointCallback(), animationDuration / 2);
        }

        el.addEventListener(
            'animationend',
            () => {
                el.classList.remove(animationClass);

                onFinishCallback();

                // Are there any more animations left in this sequence?
                if (animations.length) {
                    executeAnimationSequence(el, animations);
                }
            },
            { once: true }
        );

        // Instantly finish if no class was given
        if (! animationClass) {
            el.dispatchEvent(new AnimationEvent('animationend'));
        }
    }, animationDelay);
}

export function triggerBackInStockNotificationAnimation(el) {
    const backInStockIcon = el.querySelector('i');

    executeAnimationSequence(backInStockIcon,[
        {
            classToAdd: 'animated-buttons__scale',
            relativeDelay: 0,
            duration: 600,
            onHalfwayPoint: () => {
                backInStockIcon.classList.remove('fa-envelope');
                backInStockIcon.classList.add('fa-envelope-open');
            }
        },
        {
            classToAdd: null,
            relativeDelay: 1000,
            onFinish: () => {
                backInStockIcon.classList.remove('fa-envelope-open');
                backInStockIcon.classList.add('fa-envelope');
            }
        }
    ]);
}

export function triggerAddToCartButtonAnimation(el) {
    const addToCartButtonIcon = el.querySelector('i');

    executeAnimationSequence(addToCartButtonIcon,[
        {
            classToAdd: 'animated-buttons__rotate',
            relativeDelay: 0,
            duration: 600,
            onHalfwayPoint: () => {
                addToCartButtonIcon.classList.remove('fa', 'fa-shopping-cart');
                addToCartButtonIcon.classList.add('fal', 'fa-check-circle');
            }
        },
        {
            classToAdd: 'animated-buttons__rotate',
            relativeDelay: 3000,
            duration: 600,
            onHalfwayPoint: () => {
                addToCartButtonIcon.classList.remove('fal', 'fa-check-circle');
                addToCartButtonIcon.classList.add('fa', 'fa-shopping-cart');
            }
        },
    ]);
}

export function triggerAddToCartAnimation(el) {
    const articleAmountIcon = el.querySelector('.btn__article-amount-icon');
    const articleAmount     = el.querySelector('.btn__article-amount');
    const cartIcon          = el.querySelector('#js-cart-button-icon');

    executeAnimationSequence(articleAmountIcon,[
        {
            classToAdd: 'animated-buttons__scale-large'
        }
    ]);

    executeAnimationSequence(articleAmount,[
        {
            classToAdd: 'animated-buttons__scale-small'
        }
    ]);

    executeAnimationSequence(cartIcon,[
        {
            classToAdd: 'animated-buttons__cart'
        }
    ]);
}
